import axios from 'axios';

export default class ResetPasswordRequest {
    static getUrl = url => process.env.baseHref + url;

    static getLastDigits(username) {
        return axios({
            method: 'GET',
            url: this.getUrl('/api/auth/v2/reset-password/verification-methods?login=' + username)
        });
    }

    static sendVerificationCode(login, phoneNumber) {
        return axios({
            method: 'POST',
            url: this.getUrl('/api/auth/v2/reset-password/send-verification-message'),
            withCredentials: true,
            data: {
                login: login,
                verificationMethodType: 'sms',
                reference: phoneNumber
            }
        });
    }

    static checkVerificationCode(code) {
        return axios({
            method: 'PUT',
            url: this.getUrl('/api/auth/v2/reset-password/verify-user'),
            data: {
                verificationMessage: code,
                verificationMethodType: 'sms'
            }
        })
    }

    static resetPassword(newPassword) {
        return axios({
            method: 'PUT',
            url: this.getUrl('/api/auth/v2/reset-password/set-new-password'),
            data: {
                newPassword: newPassword
            }
        });
    }
}




// WEBPACK FOOTER //
// ./src/scripts/services/resetPasswordRequest.js